import * as React from 'react';
import { SVGProps } from 'react';

const IconOpenInNewSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m4.987 7.715 5.016-5.008V6h1V1H6v1h3.296L4.28 7.008l.707.707z" />
    <path d="M5 3v1H2v6h6V7h1v4H1V3h4z" />
  </svg>
);
export default IconOpenInNewSizeXs;
